import { RadioButtonOption } from "apps/portal/src/components/atoms";

import { OtherResourcesRequired, ResourceRequired } from "../../types";

export const RESOURCE_REQUIRED_OPTIONS: RadioButtonOption<ResourceRequired>[] =
  [
    { label: "Staff", value: "STAFF" },
    { label: "Facility", value: "FACILITY" },
  ];
export const OTHER_RESOURCES_REQUIRED_OPTIONS: RadioButtonOption<OtherResourcesRequired>[] =
  [
    { label: "Yes", value: "YES" },
    { label: "No", value: "NO" },
  ];
